import { inject, injectable, interfaces } from 'inversify';
import { ProjectStatus } from '../../../../../__legacy__/modules/projects/projects.model';
import { WorkspaceRole } from '../../../../../__legacy__/modules/workspaces/workspaces.store';
import { ICurrentWorkspaceStore } from '../../../../workspaces/currentWorkspace/CurrentWorkspace.store';

export interface ImportAnnotationsPermissions {
  canImportAnnotations(projectStatus: ProjectStatus): boolean;
}

export namespace ImportAnnotationsPermissions {
  export const $: interfaces.ServiceIdentifier<ImportAnnotationsPermissions> = Symbol('IMPORT_ANNOTATIONS_PERMISSIONS');
}

@injectable()
export class ImportAnnotationsPermissionsImpl implements ImportAnnotationsPermissions {
  constructor(@inject(ICurrentWorkspaceStore.$) private readonly currentWorkspaceStore: ICurrentWorkspaceStore) {}

  canImportAnnotations(projectStatus: ProjectStatus): boolean {
    const currentWorkspaceRole = this.currentWorkspaceStore.currentWorkspace.role;
    return (
      projectStatus === ProjectStatus.Published &&
      [WorkspaceRole.Owner, WorkspaceRole.Manager, WorkspaceRole.Developer, WorkspaceRole.Trainer, WorkspaceRole.Collaborator].includes(currentWorkspaceRole)
    );
  }
}
